export default "__VITE_ASSET__4dI1e15W__"